module.exports = __webpack_public_path__ + "static/img/top_pic.d3e7456.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top_pic.png
// module id = UWyg
// module chunks = 1